import type { RowSelectionState } from "@tanstack/react-table";

type SelectableRow = {
  id: string;
  getCanSelect: () => boolean;
};

export function getSelectableRowSelection(rows: SelectableRow[]): RowSelectionState {
  const selection: RowSelectionState = {};
  for (const row of rows) {
    if (row.getCanSelect()) {
      selection[row.id] = true;
    }
  }
  return selection;
}
